<template>
  <Dialog
    @submit="onSubmit"
    :title="title"
  >
    <form @submit.prevent="onSubmit">
      <div class="form-group">
        <label for="amount">Amount*</label>
        <input
          type="number"
          v-validate="'required'"
          id="amount"
          name="amount"
          class="form-control"
          :class="{'is-invalid': errors.has('amount')}"
          v-model.trim="amount"
          autofocus
        >
        <small v-show="errors.has('amount')" class="invalid-feedback">
          {{ errors.first('amount') }}
        </small>
      </div>

      <div class="form-group">
        <label for="description">Description*</label>
        <textarea
          class="form-control main-textarea"
          rows="3"
          v-model="notes"
          v-validate="'required'"
          id="description"
          name="description"
          :class="{'is-invalid': errors.has('description')}"
          placeholder="Enter description"
        ></textarea>
        <small v-show="errors.has('description')" class="invalid-feedback">
          {{ errors.first('description') }}
        </small>
      </div>
      <div>
        Currency: <span class="badge badge-warning">{{currency.name}} ({{currency.code}})</span>
      </div>
      <!--<div>-->
        <!--Current balance: {{currentBalance}}-->
      <!--</div>-->
      <!--<div>-->
        <!--New Balance: {{newBalance}}-->
      <!--</div>-->
    </form>
  </Dialog>
</template>

<script>
import Switches from 'vue-switches';
import Dialog from '@/components/Dialog';
import ModalMixin from '@/mixins/ModalMixin';

import COMPANY from '@/graphql/Companies/Company.gql';
import CURRENCIES from '@/graphql/Currencies/Currencies.gql';
import CREATE_TRANSACTION from '@/graphql/Transactions/NewTransaction.gql';
import BALANCE from '@/graphql/Balance/Balance.gql';

export default {
  name: 'add-transaction-component',
  mixins: [ModalMixin],
  components: {
    Dialog,
    Switches,
  },
  data() {
    return {
      id: this.$route.params.id,
      transaction: {
        amount: 0,
        notes: 0,
      },
      currency: {},
      currencies: [],
      balance: '',
    };
  },
  computed: {
    title() {
      return 'Create New Transaction';
    },
    newBalance() {
      return this.balance + +this.transaction.amount;
    },
    amount: {
      get() {
        return (this.transaction && this.transaction.amount) || '';
      },
      set(val) {
        this.transaction.amount = val;
      },
    },
    currentBalance: {
      get() {
        return this.balance || 0;
      },
      set(val) {
        this.balance = val;
      },
    },
    notes: {
      get() {
        return (this.transaction && this.transaction.notes) || '';
      },
      set(val) {
        this.transaction.notes = val;
      },
    },
  },
  methods: {
    async onSubmit() {
      try {
        const isValid = await this.$validator.validateAll();
        if (!isValid) {
          return;
        }
      } catch (e) {
        return;
      }

      this.createTransaction();
    },

    getCurrency(companyCurrency) {
      const defaultCurrency = {
        name: 'Not set',
      };

      return this.currencies.find(currency => +currency.id === +companyCurrency) || defaultCurrency;
    },
    createTransaction() {
      this.$apollo
        .mutate({
          mutation: CREATE_TRANSACTION,
          variables: {
            id: parseInt(this.id),
            input: {
              notes: this.transaction.notes,
              amount: parseFloat(this.transaction.amount),
              currencyId: parseInt(this.currency.id),
            },
          },
          refetchQueries: ({ data }) => {
            const response = data.createTransaction;
            return response && response.success ? ['transactions'] : [];
          },
        })
        .then(() => {
          this.$notify({
            group: 'success',
            type: 'success',
            text: 'Transaction was created',
          });
          this.close();
        })
        .catch(e => {
          this.$notify({
            group: 'error',
            type: 'error',
            text: e.message,
          });
        });
    },
  },

  apollo: {
    currencies: {
      query: CURRENCIES,
      fetchPolicy: 'cache-and-network',
      result({ data, loading }) {
        if (!loading) {
          this.currencies = data.currencies;
        }
      },
    },
    company: {
      query: COMPANY,
      fetchPolicy: 'cache-and-network',
      variables() {
        return {
          id: +this.id,
        };
      },
      result({ data, loading }) {
        if (!loading) {
          this.currency = this.getCurrency(data.company.currency);
        }
      },
      skip() {
        return !this.id;
      },
    },
    transaction: {
      query: BALANCE,
      fetchPolicy: 'cache-and-network',
      variables() {
        return {
          id: +this.id,
        };
      },
      result({ data, loading }) {
        if (!loading) {
          this.balance = data.balance ? data.balance.balance : 0;
          this.transaction = {
            amount: '',
            notes: '',
          };
        }
      },
      skip() {
        return !this.id;
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.form-group {
  margin-bottom: 12px;
}
.vue-switcher {
  margin-left: 20px;
  margin-bottom: 0;
  top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/modals/AddTransactionModal.vue